module.exports = __webpack_public_path__ + "static/media/17b-01-HOME_ST-2017-200x300cm-oleo-sobre-madera.381d9910.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17b/17b-01-HOME_ST-2017-200x300cm-oleo-sobre-madera.jpg
// module id = 207
// module chunks = 0